/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Twda_Failed_ConfigInputs */



/**
* | output |
* | --- |
* | "the GitHub App key on this server cannot be read" |
*
* @param {Twda_Failed_ConfigInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const twda_failed_config = /** @type {((inputs?: Twda_Failed_ConfigInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Twda_Failed_ConfigInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("la clé de l'App GitHub de ce serveur est illisible")
	if (locale === "es") return /** @type {LocalizedString} */ ("la clave de la App de GitHub de este servidor no se puede leer")
	if (locale === "pt") return /** @type {LocalizedString} */ ("a chave do App do GitHub neste servidor não pode ser lida")
	if (locale === "it") return /** @type {LocalizedString} */ ("la chiave dell'App GitHub su questo server non è leggibile")
	return /** @type {LocalizedString} */ ("the GitHub App key on this server cannot be read")
});